import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';
import './index.scss';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { useMedia } from '@commons/media';
import { Element } from 'react-scroll';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import RootStore from '@stores';
import { useTranslation } from 'react-i18next';
interface RewardsProps {
}
const HowTo:React.FC<RewardsProps> = observer((props)=> {
    const {mbMatches, tlMatches, webMatches,minWebMatches, mediaClass} = useMedia();

    const {i18n} = useTranslation();
    const language = i18n.language
    const [howtoOpen, setHowtoOpen] = useState(true);

    const [swiperParams] = useState<SwiperOptions>({
        autoplay: false,
        loop:false,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        modules: [Navigation, Pagination, EffectFade],
        pagination: {
            el: ".swiper-pagination",
            renderBullet: function (index, className) {
                return `<span class='${className}'></span>`;
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        on: {
            init(swiper: Swiper) {
                if (swiper.slides.length <= 1) {
                    swiper.navigation.nextEl.style.display = 'none';
                    swiper.navigation.prevEl.style.display = 'none';
                }
            }
        }
    })

    const [mgmTacticals, setMgmTacticals] = useState([])

    const {
        portalContent
    } = RootStore.PortalStore;


    useEffect(() => {
        let langMgmTacticals = i18n.getResource(language, "portal", "mgmTacticals")
        if (langMgmTacticals) {
            setMgmTacticals(langMgmTacticals)
            console.log(langMgmTacticals, 'mgmTacticals');
        }
    }, [portalContent, language, i18n])
    
    
    const handleExpand = () => {
        setHowtoOpen(!howtoOpen)
    }

    const openTacticalLink = (link: string) => {
        if (link) {
            window.open(link)
        }
    }
    
    useEffect(() => {
        const swiper = new Swiper('.howto-swiper', swiperParams)
    }, [howtoOpen, swiperParams])

    
    return (
        <Element name="how-to">
            <Grid container item xs={12} justifyContent='center'>
                <Grid container className={`main-qna-maxwidth howto-header`}>
                    <Grid container className={`${mediaClass('howto-header-title')}`} justifyContent='center' alignItems='center'>
                        <h2>{i18n.t('portal:HowToTitle')}</h2>
                        {
                            howtoOpen ? 
                            <FontAwesomeIcon icon={faChevronUp} className={`${mediaClass('howto-icon')}`} onClick={handleExpand} />
                            : <FontAwesomeIcon icon={faChevronDown} className={`${mediaClass('howto-icon')}`} onClick={handleExpand} />
                        }
                    </Grid>
                </Grid>
                {
                    howtoOpen ? (
                            <div className="howto-swiper swiper" >
                                <div className="swiper-wrapper">
                                    {
                                        mgmTacticals && mgmTacticals.map((item:any, i) => (
                                            <div 
                                                className="swiper-slide" 
                                                key={i} 
                                                onClick={() => openTacticalLink(item.link)}
                                                style={{cursor: item.link ? 'pointer' : 'default'}}
                                            >
                                                {
                                                    mbMatches ? <div className={`${mediaClass('howto-slide-img')}`} ><img src={item.mobileBannerImageUrl} style={{width: '100%', objectFit: 'contain'}} alt="" /></div> : <></>
                                                }
                                                {
                                                    tlMatches ? <div className='howto-slide-img'><img src={item.tabletBannerImageUrl} style={{width: '100%', objectFit: 'contain'}} alt="" /></div> : <></>
                                                }
                                                {
                                                    minWebMatches ? <div className='howto-slide-img'><img src={item.desktopBannerImageUrl} style={{width: '100%', objectFit: 'contain'}} alt="" /></div> : <></>
                                                }
                                                {
                                                    webMatches ? <div className='howto-slide-img'><img src={item.desktopBannerImageUrl} style={{width: '100%', objectFit: 'contain'}} alt="" /></div> : <></>
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className="swiper-pagination"></div>
                                <div className={`swiper-button-prev ${mediaClass('swiper-prev-btn')}`}></div>
                                <div className={`swiper-button-next ${mediaClass('swiper-next-btn')}`}></div>
                            </div>
                    ) : <></>
                }
            </Grid>
        </Element>
    )
})

export default HowTo;